/* global localStorage */

const hasLocalStorage = (function() {
	let storage, result, uid = new Date();
	try {
		(storage = localStorage).setItem(uid, uid);
		result = storage.getItem(uid) == uid; //eslint-disable-line eqeqeq
		storage.removeItem(uid);
		return result && storage;
	} catch (exception) {}
}());


export function readState() {
  return (hasLocalStorage && localStorage.getItem('reduxState')) ?
    { customize: JSON.parse(localStorage.getItem('reduxState')) } :
    {}
}

export function storeState(state) {
  if (!hasLocalStorage) return;
  let s = {...state.customize};
  delete s.selectedView;
  delete s.hydrated;
  // TODO: It would be nice to store only the instance here, but initial render fails without a putter
  localStorage.setItem('reduxState', JSON.stringify(s))
}